<div class="layout-main">
  <app-dashboard-capacity></app-dashboard-capacity>
</div>
